import React, { Component } from 'react';
import styled from 'styled-components';
import _ from 'lodash';

/**
* Colors
*/
const themeColors = ['#00ae89', '#df5c5e', '#ff6000', '#2575bb', '#7b4172', '#e7969c', '#a55094', '#843c39'];


/**
* styled components
*/
const TagBoxContainer = styled.div`
  h2 {
    text-transform: uppercase;

  }
`;

const Tags = styled.div``;

const Tag = styled.span`
  margin-right: 10px !important;
  border-radius: 10px !important;
  padding: 5px 8px !important;
  display: inline-block;
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: 500;
`;

/**
* Class TagBox
*/
class TagBox extends Component {
  renderTags(tags, colored) {
    return (
      <Tags>
      {
        _.map(tags, (tag, index) => {
          return(
            <Tag key={`boxtag-${tag}-${index}`} className="tiny-font-size report-tag" style={colored ? {color: themeColors[index]} : {}}>{tag}</Tag>
          );
        })
      }
      </Tags>
    )
  }

  render() {
    const { data } = this.props;

    return(
      <TagBoxContainer>
        {data.title ? <h2 className="normal-font-size">{data.title}</h2> : ''}
        {this.renderTags(data.tags, data.colored)}
      </TagBoxContainer>
    );
  }
}

export default TagBox;



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/TagBox.js